module.exports = __webpack_public_path__ + "static/img/6.c1c6cf0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/6.png
// module id = ne2z
// module chunks = 0